import { createContext, useContext, useEffect, useMemo, useState } from 'react';


const AuthContext = createContext();

export default function AuthProvider({ children }) {
    const accessToken = localStorage.getItem('token') || null
    const [isAuth, setIsAuth] = useState(accessToken ? true : false);
    const [token, setToken] = useState(accessToken)

    useEffect(() => {
        if (token) {
            localStorage.setItem('token', token)
            setIsAuth(true)
        }
        else{
            setIsAuth(false)
        }
    }, [token])

    const value = useMemo(
        () => ({
            isAuth,
            setToken
        }),
        [isAuth]
    );
    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export function useAuth() {
    return useContext(AuthContext);
}